import React from "react";
import OPOfflineIframe from "../../../iframe-component/operation-offline/OPOffIframe";

const Web = () => {
  return <OPOfflineIframe path="/operation/notice" />;
};

export default React.memo(Web);
